import dayjs from 'dayjs';

// let offset = date.getTimezoneOffset() * 60000; //ms단위라 60000곱해줌
// let dateOffset = new Date(date.getTime() - offset);
// console.log(dateOffset.toISOString());

type Props = {
  showTime?: boolean;
};

export function dateAgo(createAt: any, showTime: boolean = true) {
  if (createAt) {
    const value = createAt.seconds
      ? createAt.seconds * 1000
      : createAt._seconds * 1000; //1605600280000 ...

    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      // 159452 ...

      // less than 30 seconds ago will show as 'Just now'
      if (seconds < 29) {
        return '방금';
      }
      const intervals = {
        일: 86400,
        시간: 3600,
        분: 60,
        초: 1,
      };
      let counter;

      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);

        if (counter > 0) {
          if (counter === 1) {
            return `${counter}${i} 전`; // singular (1 day ago)
          } else {
            if (seconds > 259200) {
              // 올해 연도와 같으면 YYYY생략
              const thisYear = new Date().getFullYear();
              const compareYear = new Date(value).getFullYear();

              if (thisYear === compareYear) {
                return showTime
                  ? dayjs(value).format('MM.DD HH:mm')
                  : dayjs(value).format('MM.DD');
              }
              return showTime
                ? dayjs(value).format('YYYY.MM.DD HH:mm')
                : dayjs(value).format('YYYY.MM.DD'); // 3일까지만 '전'으로 나타냄
            }
            return `${counter}${i} 전`; // plural (2 days ago)
          }
        }
      }
    }

    return value;
  }
}

export function timestampToDateString(
  initialValue: any,
  format?: string,
): string {
  const safeFormat = format || 'YYYY-MM-DD';

  if (!initialValue) return ''; // null, undefined 등 처리

  // 1. Firestore Timestamp 객체: { seconds, nanoseconds }
  if (typeof initialValue === 'object') {
    const seconds =
      initialValue.seconds ??
      initialValue._seconds ?? // Algolia에서 온 경우
      null;

    if (typeof seconds === 'number') {
      return dayjs(seconds * 1000).format(safeFormat);
    }
  }

  // 2. 문자열 또는 Date 객체
  const parsed = dayjs(initialValue);
  return parsed.isValid() ? parsed.format(safeFormat) : '';
}

export function timestampToDate(initialValue: any): Date | null {
  if (!initialValue) return null;
  if (typeof initialValue === 'object') {
    const setValue = initialValue.seconds * 1000;
    return new Date(setValue);
  } else {
    return new Date(initialValue * 1000);
  }
}

export function dateToTimestamp(value) {
  return Math.round(new Date(value).getTime() / 1000);
}

export function nowDateToTimestamp() {
  return Math.round(new Date().getTime());
}
